import { Controller } from "@hotwired/stimulus"

// Ticks days/hours/minutes/seconds down to targetValue every second.
// Server only sends the target timestamp — no reason to round-trip the page
// just to keep the numbers moving.
export default class extends Controller {
  static targets = ["days", "hours", "minutes", "seconds"]
  static values = { target: String }

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    const diff = new Date(this.targetValue) - new Date()

    if (diff <= 0) {
      this.render(0, 0, 0, 0)
      clearInterval(this.timer)
      return
    }

    const totalSeconds = Math.floor(diff / 1000)
    this.render(
      Math.floor(totalSeconds / 86400),
      Math.floor((totalSeconds % 86400) / 3600),
      Math.floor((totalSeconds % 3600) / 60),
      totalSeconds % 60
    )
  }

  render(days, hours, minutes, seconds) {
    this.daysTarget.textContent = days
    this.hoursTarget.textContent = String(hours).padStart(2, "0")
    this.minutesTarget.textContent = String(minutes).padStart(2, "0")
    this.secondsTarget.textContent = String(seconds).padStart(2, "0")
  }
}
